import React, { useState } from "react";
import { Link, redirect, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Auth from "service/AuthService";
import { useAuth } from "provider/AuthContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import login1 from "assets/images/loginImage/login1.png";
import login2 from "assets/images/loginImage/login2.png";
import Modal from "components/ui/Modal";
import Button from "components/ui/Button";
import InputField from "components/ui/forms/InputField";
import InputRC from "components/ui/forms/InputRC";
import Logo from "assets/images/logo.jpg";
import { FormMessage } from "components/ui/forms/FormMessage";
import { API_URL } from "helper/Constants";
import { useTranslation } from "react-i18next";

const Login = ({ onLoginSuccess, isOpen, onClose, handleRegisterClick }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isAcknowledge, setIsAcknowledge] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();
  const { updateUser } = useAuth();
  const navigate = useNavigate();
  const authApi = new Auth(API_URL);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    // if (process.env.REACT_APP_ENV === "local") {
    //   onLoginSuccess(true);
    //   return;
    // }
    try {
      const response = await authApi.loginUser(data);
      if (response.success) {
        updateUser(response.user);

        if (onLoginSuccess) {
          await onLoginSuccess(response.user);
        }

        if (response.user?.role === "User") {
          navigate("/");
        } else {
          window.location.href = "/admin/transfer";
          // navigate("/admin/transfer");
        }
      } else {
        setErrorMessage(response.message || "Failed to login. Please try again.");
      }
      // setErrorMessage("");
    } catch (error) {
      console.error("Error during login:", error);
      setErrorMessage(error.response?.data.message || "An error occurred during login. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="sm:max-w-[400px] w-full"
      title={
        <>
          <Link to="/" className="h-[37px] max-w-[100px] flex items-center">
            <img src={Logo} alt="logo" />
          </Link>
          <div className="px-4 ml-auto mr-8">
            <Button label="REGISTER" size="small" className="bg-primary py-0 uppercase leading-6 !text-[12px]" onClick={handleRegisterClick} />
          </div>
        </>
      }
    >
      <hr className="border-b border-[rgb(88,88,80,50%)]" />
      <div className="ml-4 mr-4 mt-2">
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <h2 className="text-[15px] text-slate-400 mt-2">{t("Already have an account?")}</h2>
          <p className="text-[17px] mb-3 mt-1 uppercase">{t("Sign in, we are waiting for you")}</p>
          {errorMessage && <FormMessage className="mb-3" message={errorMessage}></FormMessage>}

          <div className="md:space-y-3 space-y-2">
            <InputField
              type="text"
              name="username"
              label="Username"
              control={control}
              inputClassName="lowercase"
              onChange={(e) => {
                const lowercaseValue = e.target.value.toLowerCase();
                setValue("username", lowercaseValue, { shouldValidate: true });
              }}
              {...register("username", { required: "Username is required" })}
              error={errors.username?.message}
              autoCapitalize="none"
            />

            <InputField
              type={showPassword ? "text" : "password"}
              name="password"
              label="Password"
              control={control}
              {...register("password", { required: "Password is required" })}
              error={errors.password?.message}
              postfixAction={() => setShowPassword(!showPassword)}
              postfix={!showPassword ? <FaEye className="text-primary-dark" size={24} /> : <FaEyeSlash className="text-primary-dark" size={24} />}
            />
            <InputRC name="acknowledge" checked={isAcknowledge} onChange={() => setIsAcknowledge(!isAcknowledge)} label="Remember Me" />
          </div>
          <button
            type="submit"
            className="bg-[rgb(16,145,33,1)] w-full font-medium px-2 py-2 mb-5 rounded-[3px] uppercase leading-3 text-sm transition duration-300 bg-fillButton h-9 mt-3 text-primary-dark disabled:opacity-50 disabled:hover:bg-fillButton hover:bg-[rgb(21,190,43,1)]"
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "SIGN IN"}
          </button>

          <div className="flex items-center w-full max-w-lg">
            <hr className="flex-grow border-[rgb(38,43,50,1)]" />
            <span className="mx-4 text-slate-400 font-medium">OR</span>
            <hr className="flex-grow border-[rgb(38,43,50,1)]" />
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              className="bg-slate-800 w-full max-w-[50%] font-medium px-2 py-2 mb-3 rounded-[3px] uppercase leading-3 text-[12px] transition duration-300 bg-fillButton h-9 mt-3 text-primary-dark disabled:opacity-50 disabled:hover:bg-fillButton hover:bg-[rgb(255,255,255,0.35)]"
            >
              SELECT NETWORK
            </button>
            <button
              type="button"
              className="bg-slate-800 w-full max-w-[50%] font-medium px-2 py-2 mb-3 rounded-[3px] leading-3 text-sm transition duration-300 bg-fillButton h-9 mt-3 text-primary-dark disabled:opacity-50 disabled:hover:bg-fillButton hover:bg-[rgb(255,255,255,0.35)]"
            >
              WalletConnect
            </button>
          </div>

          <div className="flex gap-3">
            <a href="#" className="cursor-pointer sm:block hidden">
              <img src={login1} alt="login-image" />
            </a>
            <a href="#" className="cursor-pointer">
              <img src={login2} alt="login-image" />
            </a>
          </div>

          <div className="flex flex-col items-center justify-center">
            <button
              type="button"
              className="flex gap-4 text-sm -ml-3 items-center uppercase hover:text-[rgb(255,255,255,0.9)] text-[rgb(255,255,255,0.7)] py-1.5 bg-no-repeat rtl:bg-right cursor-pointer font-medium mt-6"
            >
              {t("Forgot your Password?")}
            </button>
            <div className="min-h-[clac(100vh-400px)] max-h-32 flex items-end py-3 text-sm mt-[1rem] mb-[.5rem] text-white/50">
              <i className="bc-i-live-chat text-[16px]" />{" "}
              <Link to="#" className="ml-2 underline leading-3">
                Contact Support
              </Link>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default Login;
